// extracted by mini-css-extract-plugin
export var collapsedSummary = "_sa-0";